import Image from '../../../assets/ContactUsNew.jpg'
import PhoneImage from '../../../assets/phone.png'
import EmailImage from '../../../assets/mail.png'
import LocationImage from '../../../assets/location.png'
import { zodResolver } from '@hookform/resolvers/zod'
import { FormProvider, useForm } from 'react-hook-form'
import FormBuilder from '../../../components/app/formBuilder'
import { useDistrictList, useRegister } from './api'
import { registrationSchema, RegistrationSchema } from './schema'
import { useNavigate } from 'react-router-dom'

const ContactUs = () => {
  const { data } = useDistrictList()
  const navigate = useNavigate()
  const methods = useForm<RegistrationSchema>({
    resolver: zodResolver(registrationSchema),
    mode: 'onChange',
    defaultValues: {
      first_name: '',
      last_name: '',
      email: '',
      phone_number: '',
      message: '',
    },
  })

  const onSuccess = (data: any) => {
    console.log('Registration successful:', data)
    methods.reset()
    navigate('/')
  }

  const { mutate: registerUser, isPending } = useRegister(onSuccess)

  const onSubmit = (data: RegistrationSchema) => {
    registerUser(data)
  }

  const personalInformation = [
    {
      name: 'first_name' as const,
      label: 'First Name',
      type: 'text' as const,
      required: true,
      disabled: false,
      placeholder: 'Enter your first name',
    },
    {
      name: 'last_name' as const,
      label: 'Last Name',
      type: 'text' as const,
      required: true,
      disabled: false,
      placeholder: 'Enter your last name',
    },
    {
      name: 'email' as const,
      label: 'Email address',
      type: 'email' as const,
      required: true,
      disabled: false,
      placeholder: 'Enter your email',
    },
    {
      name: 'phone_number' as const,
      label: 'Phone Number',
      type: 'number' as const,
      required: true,
      disabled: false,
      placeholder: 'Enter your Phone Number',
    },
    {
      name: 'district' as const,
      label: 'District',
      type: 'custom_select' as const,
      required: true,
      disabled: false,
      desc: 'name',
      descId: 'id',
      placeholder: 'Select your District',
      data: data?.data?.map((item: any) => ({
        id: item.id,
        name: item?.district_institution ?? item?.district_name ?? item?.name,
      })),
    },
    {
      name: 'service' as const,
      label: 'Type of Service',
      type: 'custom_select' as const,
      placeholder: 'Select Type of Service',
      required: true,
      disabled: false,
      desc: 'name',
      descId: 'id',
      id: 'service',
      data: [
        { name: 'Training', id: 'Training' },
        { name: 'Facilitation', id: 'Facilitation' },
        { name: 'Others', id: 'Others' },
      ],
    },
    {
      name: 'address' as const,
      label: 'Address',
      type: 'text' as const,
      required: true,
      disabled: false,
      placeholder: 'Enter your Address',
    },
    {
      name: 'message' as const,
      label: 'Message',
      type: 'textarea' as const,
      required: true,
      disabled: false,
      placeholder: 'Leave a message',
    },
  ]

  return (
    <>
      {/* <div className="lg:mx-8 my-6 py-5"> */}
      <div className="lg:w-11/12 mx-auto p-4 lg:p-0 lg:my-8">
        <div className="flex flex-col lg:flex-row">
          <div className=" my-6 lg:py-10 py-5">
            <div className="flex flex-col lg:flex-row gap-14 items-stretch">
              {/* <div className="lg:w-1/2 gap-4 ">
                <img
                  src={Image}
                  alt="EDC Discussion"
                  className="rounded-lg w-full h-full object-cover"
                />
              </div> */}
              <div className="lg:w-1/2 gap-4">
                <img
                  src={Image}
                  alt="EDC Discussion"
                  className="rounded-lg w-full  object-contain"
                />
              </div>

              <div className="lg:w-[80%] px-8 rounded-2xl flex flex-col justify-between">
                <h2 className="text-[24px] text-PrimaryGray mb-5 leading-[14px]">
                  Get In Touch
                </h2>
                <div className="border-b border-primaryBlue mb-8">
                  <h2 className="text-3xl font-semibold mb-5">
                    Reach Out To Us
                  </h2>
                  <p className="mb-5 text-md text-gray-900">
                    Have questions or feedback? We&apos;re here to help. Send us
                    a message, and we’ll respond within 24 hours
                  </p>
                </div>

                <form
                  onSubmit={methods.handleSubmit(onSubmit)}
                  className="flex-1 flex flex-col justify-between"
                >
                  <FormProvider {...methods}>
                    <div className="w-full">
                      <div className="grid grid-cols-2 gap-8 lg:mb-10">
                        <FormBuilder
                          data={personalInformation.filter(
                            (field) =>
                              field.name === 'first_name' ||
                              field.name === 'last_name' ||
                              field.name === 'phone_number' ||
                              field.name === 'district' ||
                              field.name === 'service' ||
                              field.name === 'address' ||
                              field.name === 'email'
                          )}
                          edit
                        />
                      </div>

                      <div className="grid grid-cols-1 gap-8 lg:mb-10">
                        <FormBuilder
                          data={personalInformation.filter(
                            (field) => field.name === 'message'
                          )}
                          edit
                        />
                      </div>

                      <button
                        type="submit"
                        disabled={isPending || !methods.formState.isValid}
                        className={`w-full ${
                          isPending || !methods.formState.isValid
                            ? 'bg-primaryBlue cursor-not-allowed'
                            : 'bg-primaryBlue hover:bg-orange-600'
                        } text-white font-semibold py-2 rounded transition mt-10`}
                      >
                        {isPending ? 'Sending...' : 'Send'}
                      </button>
                    </div>
                  </FormProvider>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-Contactbg  mt-12">
        <div className="  p-4 rounded-xl grid grid-cols-1 md:grid-cols-3 gap-6 text-sm text-black lg:w-11/12 lg:mx-auto">
          <div className="flex flex-col items-center justify-center border-r-2 border-primaryBlue">
            <div className="flex items-start gap-2">
              <div>
                <h3 className="font-semibold uppercase">
                  or just reach us manually
                </h3>
                <div className="space-y-2 text-xs">
                  {/* Phone row */}
                  <div className="flex items-center">
                    <div className="flex items-center gap-2 w-36">
                      {' '}
                      {/* fixed width */}
                      <img src={PhoneImage} alt="Phone" className="w-5 h-5" />
                      <p className="font-medium">Phone Number</p>
                    </div>
                    <p>0484 2550322</p>
                  </div>

                  {/* Email row */}
                  <div className="flex items-center">
                    <div className="flex items-center gap-2 w-36">
                      {' '}
                      {/* same width as above */}
                      <img src={EmailImage} alt="Email" className="w-5 h-5" />
                      <p className="font-medium">Mail ID</p>
                    </div>
                    <p>ceo.kied@gmail.com</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center border-r-2 border-primaryBlue">
            <div className="flex items-center gap-2 text-xs">
              <div>
                <img src={LocationImage} alt="Location" className="w-5 h-5" />
              </div>
              <div>
                <p className="font-medium">
                  Enterprise Development Centre (EDC),
                </p>
                <p>4th Floor, Inkel Tower 1,</p>
                <p>Inkel Business Park, Angamaly,</p>
                <p>Ernakulam</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col items-center justify-center">
            <div className="flex items-center gap-2 text-xs">
              <div>
                <img src={LocationImage} alt="Location" className="w-5 h-5" />
              </div>
              <div>
                <p className="font-medium">
                  Kerala Institute For Entrepreneurship
                </p>
                <p>Development (KIED) Rockwell Road,</p>
                <p>HMT Colony PO,</p>
                <p>Kalamassery, Cochin - 683 503</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ContactUs
